import React, { useState, useEffect } from 'react'
import Modal from '../../../components/modal';
import { Button } from '../../../components/ui/button';
import { Link } from 'react-router-dom';
import Contact from '../../popups/contact';

const taglines = [
	"tell us what you like, we tell you who to meet", 
	"look who's looking for you",
	"skip the crowd, meet the cream",
	"next door gems", 
	"small groups are a big deal",
	"your kind of special snowflakes", 
	"greet online, meet offline",
]

function scrollToSignup(e: React.MouseEvent<HTMLAnchorElement>) {
	e.preventDefault()
	document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' })
}

// public/llms.txt, public/llms-full.txt and the meta description in index.html restate this landing copy
// for crawlers: keep them in sync when editing the copy here.
export default function About() {
	const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);
	const [fade, setFade] = useState(false);
	const [contactOpen, setContactOpen] = useState(false);

	useEffect(() => {
		const intervalId = setInterval(() => {
			setFade(true)
			setTimeout(() => {
				setCurrentTaglineIndex((prevIndex) => (prevIndex + 1) % taglines.length)
				setFade(false)
			}, 750)
		}, 4000)

		return () => clearInterval(intervalId)
	}, [])

	return (
		<div className="flex flex-col items-center justify-between h-full overflow-y-auto text-gray-800 p-4">
			<div>
				<img src="/assets/logo-beta.png" alt="logo" className="w-64 md:w-80 mb-4"/>

				<div className="mb-8 h-16 w-full flex items-start justify-start">
					<div 
						id="tagline" 
						className={`text-start font-fancy text-xl font-black text-rose-600
							transition-opacity duration-500 ${fade ? 'opacity-0' : 'opacity-100'}
							[will-change:opacity] [transform:translateZ(0)]
              				[backface-visibility:hidden] [contain:paint]`}
					>
						{taglines[currentTaglineIndex]}
					</div>
				</div>
				
				<div className="mb-6 space-y-1 text-start text-base font-title font-black text-gray-600">
				{/* <div className="mb-8 mt-8 space-y-1 text-center text-lg border border-rose-600 rounded-lg p-4 shadow-lg"> */}
					{/* <p>Get invited to small chat groups with people near you, each around a topic you all share an interest in.</p> */}
					{/* <p>Get invited to small chat groups about topics you like, with people near you.</p> */}
					<p>We start chat groups for 5-10 neighbors around shared interests.</p>
					<p>Have a good chat, and if things click, take it offline!</p>
				</div>
				<div className="mb-8 space-y-1 text-start text-sm font-main text-gray-600">
					<p>Open in Vancouver, waitlist worldwide.</p>
				</div>
				<p className="mb-4 pl-6 font-bold text-sm font-title text-rose-600">How?</p>
				<ul className="list-disc pl-4 mb-6 space-y-1 text-sm">
					<li className="pl-2">
						{/* a link only on mobile, where the signup panel stacks below this text; on desktop the panel
						is already beside it. Scrolls directly rather than via the hash, so a repeat click (hash
						unchanged) still scrolls. */}
						Quick, free <a
							href="#signup"
							onClick={scrollToSignup}
							className="text-rose-600 underline md:text-inherit md:no-underline md:pointer-events-none"
						>signup</a>: pick your area, write a few words about yourself.
					</li>
					<li className="pl-2">You can chat with our bot to refine your profile for even better group matches.</li>
					<li className="pl-2">We'll start small chat groups for you and a handful of people near you, each around a topic you all share an interest in.</li>
					<li className="pl-2">While you wait, our bot can recommend you books, movies, places, and more.</li>
				</ul>
				<p className="mb-4 pl-6 font-bold text-sm font-title text-rose-600">Why?</p>
				<ul className="list-disc pl-4 mb-6 space-y-1 text-sm">
					<li className="pl-2">There are more interesting people around us than we know -- it's just hard to find them.</li>
					<li className="pl-2">Random encounters at the pub are too hit-or-miss.</li>
					<li className="pl-2">Social networks and online forums are crowded and noisy, and they don't focus on offline proximity.</li>
					<li className="pl-2">Reviewing profiles one by one in friend-finder apps is tedious. Plus, small-group meetings are more relaxed than one-on-one.</li>
					<li className="pl-2">We offer small groups of neighbors, pre-selected for their interest in topics you like.</li>
				</ul>	
			</div>

			<footer className="mt-auto pt-8 text-center text-gray-600">
				<p className="space-x-2">
					{/* real links, not popups: crawlers follow an href, and these pages are prerendered (see static-page.tsx) */}
					<Button asChild variant="link" className="text-rose-600 hover:text-rose-600/80"><Link to="/faq">FAQ</Link></Button>
					<Button asChild variant="link" className="text-rose-600 hover:text-rose-600/80"><Link to="/terms">Terms</Link></Button>
					<Button asChild variant="link" className="text-rose-600 hover:text-rose-600/80"><Link to="/privacy">Privacy</Link></Button>
					<Button variant="link" className="text-rose-600 hover:text-rose-600/80" onClick={() => setContactOpen(true)}>Contact</Button>
				</p>
				<Modal open={contactOpen} onOpenChange={setContactOpen}>
					<Contact />
				</Modal>
			</footer>
		</div>
	)
}

